"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.communications_search.name': 'Communications Search',
    'tools.communications_search.description': 'Search and traverse communication data including group summaries, track logs, and settings by phone number',
};
